<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 금리 안내(정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>

    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">USD</th>
          <th scope="col">KHR</th>
          <th scope="col">{{ /*금리구분*/ $t("MDEP-01-02-02-08") }}</th>
        </tr>
      </thead>

      <tbody v-if="irList.length > 0">
        <tr v-for="(ir, i) in irList" :key="i">
          <template v-if="lang === 'KOR'">
            <td>{{ ir.aplyTrmCtntKor }}</td>
            <td>{{ ir.usdRate }}</td>
            <td>{{ ir.khrRate }}</td>
            <td>{{ ir.irtDsticCtntKor }}</td>
          </template>

          <template v-else-if="lang === 'ENG'">
            <td>{{ ir.aplyTrmCtntEng }}</td>
            <td>{{ ir.usdRate }}</td>
            <td>{{ ir.khrRate }}</td>
            <td>{{ ir.irtDsticCtntEng }}</td>
          </template>

          <template v-else>
            <td>{{ ir.aplyTrmCtntLcal }}</td>
            <td>{{ ir.usdRate }}</td>
            <td>{{ ir.khrRate }}</td>
            <td>{{ ir.irtDsticCtntLcal }}</td>
          </template>
        </tr>
      </tbody>
    </table>

    <div class="info info-etc">· {{ /*영업점 내점상담 후, 금리 결정*/ $t("MDEP-01-02-02-10") }}</div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 0,

      irList: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateKh1List";

      let params = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "KH1",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "KH102"
        },
      };

      this.$post(
        path,
        params,
        this.selectSucc
      );
    },

    selectSucc(res) {
      this.irList = res.interstList;
    },
  },
};
</script>
